<modal [title]="data.title | translate" (onClose)="close()" headerBgColor="gradient-man-of-steel">
    <p body>{{data.message | translate}}</p>
    <div class="text-right" footer>
        <button type="button" class="btn btn-outline-secondary" (click)="close()">{{'common.no' | translate}}</button>
        <button type="button" class="btn btn-primary" (click)="ok()">{{'common.yes' | translate}}</button>
    </div>
</modal>